import List from '../../../components/People/Timesheet/List'
import TimesheetModal from '../../../components/People/Timesheet/TimesheetModal'
import PageTitle from '../../../elements/PageTitle'
import {Breadcrumb, Card, Layout, Row} from 'antd'
import React, {Fragment} from 'react'

const {Content} = Layout

function Timesheet(props) {
  return (
    <Fragment>
      <Content style={{margin: '0px 0px'}}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item>Team Management /</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'HR Timesheets'}
              subtitle={'Manage HR Timesheets.'}
              color={'#FF6138'}
              iconType={'solution'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{padding: 10}}>
          <Card>
            <TimesheetModal {...props} />
            <List {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

Timesheet.propTypes = {}
Timesheet.defaultProps = {}

export default Timesheet
